import React from 'react'
import UsersList from './UsersList'

export default function DeletedUsersTab ({ deletedUsers }) {
  return (
    <UsersList users={deletedUsers} />
  )
}
